import React from 'react';
import SingleProjectBlock from '../../components/SingleProjectBlock';
import { AiFillDatabase } from 'react-icons/ai';

export interface ChooseProjectScreenProps {
  projects: {
    id: number | string;
    icon: string | null;
    title: string;
    url?: string;
  }[];
  loadingProjects?: boolean;
  canCreate?: boolean;
  chooseProject: (id: number | string) => void;
  createClick?: () => void;
  createChildren?: any;
  teamSelectComponent?: any;
}

const ChooseProjectScreen: React.FC<ChooseProjectScreenProps> = ({
  projects,
  loadingProjects = false,
  canCreate = false,
  chooseProject,
  createClick = () => {},
  createChildren = null,
  teamSelectComponent = null,
}) => {
  return (
    <div className="bg-gray-800 w-full min-h-screen">
      <div className="p-14">
        <div className="max-w-5xl mx-auto">
          <div className="flex items-center justify-start">
            <h3 className="text-white font-medium text-xl">Your Projects</h3>
            {teamSelectComponent}
          </div>

          <div className="mt-6 text-gray-450">
            <>
              {projects.length === 0 && !loadingProjects && (
                <p>
                  {canCreate
                    ? 'You have not created any projects, get started with one of the options below: '
                    : 'You have not been added to any projects, contact your account admin or create a new project below'}
                </p>
              )}
            </>

            {loadingProjects && <p>Loading Projects ...</p>}
            <div className="grid grid-cols-4 gap-4">
              {projects.map((project, index) => (
                <SingleProjectBlock
                  project={project}
                  key={index}
                  onClick={() => chooseProject(project.id)}
                />
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="bg-gray-750 w-full p-14">
        <div className="max-w-5xl mx-auto">
          <h3 className="text-white font-medium text-xl mb-6">
            Create Project
          </h3>
          {canCreate ? (
            <div className="grid grid-cols-3 gap-4">
              <div
                role="button"
                onClick={() => {
                  createClick();
                }}
                className="p-10 flex flex-col items-center justify-center bg-gray-950 cursor-pointer rounded-md shadow-xl transition ease-in-out duration-150 hover:bg-gray-900"
              >
                <AiFillDatabase size={28} color="white" />
                <h3 className="text-md leading-none font-medium text-white my-3 mt-4">
                  Add Project
                </h3>
                <p className="text-sm leading-4 font-light text-gray-450 leading-2 w-10/12 pt-1 text-center">
                  Click to create a new project from scratch
                </p>
              </div>
              {createChildren}
            </div>
          ) : (
            <p className="mt-6 text-gray-400 w-1/2">
              You do not have the required permissions to create a project on
              this account, please contact your account admin.
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default ChooseProjectScreen;
